<template>
    <div>
        <h3>Your API key</h3>
        <h2>{{ apiKey }}</h2>
    </div>
</template>

<style lang="scss" scoped>
    h3 {
        text-align: center;
        text-transform: uppercase;
        opacity: .5;
        padding-top: 25px;
    }
    h2 {
        font-size: 32px;
        text-align: center;
        letter-spacing: 2px;
        padding: 30px;
    }
</style>
<script>
import store from "@/services/store";

export default {
    data: () => ({
        apiKey: ""
    }),
    created() {
        this.apiKey = store.state.id.apiKey;
    }
}
</script>